export enum GiveTabs {
  REFER = 'refer',
  REFERRALS = 'referrals',
}

export const REFERRAL_REQUIREMENT_PER_TIER: readonly number[] = [0, 5, 25, 50];
